import { render, staticRenderFns } from "./StatsEstablishments.vue?vue&type=template&id=17eadfba"
import script from "./StatsEstablishments.vue?vue&type=script&lang=js"
export * from "./StatsEstablishments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports